import React, { Component } from 'react';
import { Button, FormGroup, Typography, IconButton, TextField, MenuItem } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import baseStyle from '../../../../styles/wizardBase';
import { FormattedMessage } from 'react-intl';

class LevelWizardPage1 extends Component {

  close = () => {
    this.props.close();
  };

  render()  {
    const { classes, open, close, next, games } = this.props;
    return (
      <Dialog
        disableEscapeKeyDown
        fullWidth={true}
        open={open}
        onClose={close}
        aria-labelledby='level-dialog-title'
        PaperProps={{ classes:{ root: classes.container }}}
      >
        <DialogTitle disableTypography={true} className={ classes.title } id='level-dialog-title'>
          <Typography className={ classes.titleText } variant='h4'><FormattedMessage id='Level.title'/></Typography>
          <IconButton
            onClick={this.close}
            className={ classes.exitIcon }
            aria-label="close dialog"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.subtext}>
            <FormattedMessage id='Wizard.Level'/>
          </DialogContentText>
          <Typography gutterBottom variant='h6'><FormattedMessage id='Wizard.Level.select'/>: </Typography>
          <FormGroup classes={{ root: classes.lastName }}>
            <TextField
              select
              variant='outlined'
              label={<FormattedMessage id='General.games'/>}
              name='selected'
              value={this.props.selected}
              onChange={this.props.handleChange}
            >
              {
                games.map((game, index) => (<MenuItem key={index} value={game.id}>{game.name}</MenuItem>))
              }
            </TextField>
          </FormGroup>
          <FormGroup classes={{ root: classes.multiline }}>
            <TextField
              variant='outlined'
              classes={{ root: classes.firstName }}
              label={<FormattedMessage id='General.name'/>}
              name='name'
              type='text'
              onChange={this.props.handleChange}
            />
            <TextField
              multiline
              classes={{ root: classes.lastName }}
              variant='outlined'
              label={<FormattedMessage id='General.description'/>}
              name='description'
              type='text'
              onChange={this.props.handleChange}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={this.close} color='secondary'>
            <FormattedMessage id='General.cancel'/>
          </Button>
          <Button onClick={next} color='primary'>
            <FormattedMessage id='General.next'/>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(baseStyle)(LevelWizardPage1);